import { useOutletContext } from "react-router-dom";

export type DashBoardContextType = {
  openAddCertificates: () => void;
};

export const useDashBoardContext = () =>
  useOutletContext<DashBoardContextType>();
